import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import { CommandResult } from '../../../common/helpers/CommandResult';

export const updatePaymentDate = async (personId: string | number, loanId: string | number, paymentDate: Date | string): Promise<CommandResult> => {
    const result = await AxiosClientFactory
        .getInstance()
        .post(`api/applicants/${personId}/consumerloans/${loanId}/updatePaymentDate`, paymentDate);

    return new CommandResult(result);
};
